import User from "./acl/user";
import Role from "./acl/role";
import Permission from "./acl/permission";

import CodeBook from "./codebook/code";
import CodeBookGroup from "./codebook/group";

import Setting from "./setting";

import APM from "./monitor/apm";
import Trace from "./monitor/trace";

import Branch from "./department/branch";
import Department from "./department/department";

import WxConfig from "./weixin/wxconfig";

import FabricRecieve from "./order/fabricrecieve"

import CmProduction from "./order/cmproduction"

import OrderTrack from "./order/ordertrack"

import ShipOrder from "./shipping/shiporder"

import ShipVessel from "./shipping/shipvessel"

import ShipFabNot from "./shipping/shipfabnot"

import ShipDoc from "./shipping/shipdoc"

export default {
    User: User,
    Role: Role,
    Permission: Permission,
    CodeBook: CodeBook,
    CodeBookGroup: CodeBookGroup,
    Setting: Setting,
    APM: APM,
    Trace: Trace,
    Branch: Branch,
    Department: Department,
    WxConfig: WxConfig,
    FabricRecieve:FabricRecieve,
    CmProduction:CmProduction,
    OrderTrack:OrderTrack,
    ShipOrder:ShipOrder,
  ShipVessel:ShipVessel,
  ShipFabNot:ShipFabNot,
  ShipDoc:ShipDoc,
};



// WEBPACK FOOTER //
// ./src/api/index.js